"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _PageMedia = _interopRequireDefault(require("../../SIA-WEBSITE/PageMedia/PageMedia"));
var _JuryLinksGrid = _interopRequireDefault(require("./LinksGrid/JuryLinksGrid"));
var _AppHeader = _interopRequireDefault(require("../../AppHeader/AppHeader"));
var _JuryList = _interopRequireDefault(require("./JuryList/JuryList"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
(function () {
  const styles = ":export {\n  primary-SIAblack: #000000;\n  primary-SIAgraydark: #4c4c4c;\n  primary-SIAgrayMiddle: #a8a8a8;\n  primary-SIAgray: #d4d4d4;\n  primary-SIAgrayLight: #e8e8e8;\n  primary-SIAgrayVeryLight: #f4f4f4;\n  primary-SIAwhite: #fff;\n  primary-SIAred: #e41b13;\n  primary-SIAredDark: #99100a;\n  secondary-SIAazure: #8caddb;\n  secondary-SIAazureLight: #e9eff7;\n  secondary-SIAbronze: #b1997e;\n  secondary-SIAbronzeLight: #efebe5;\n  secondary-SIAgreen: #2fb789;\n  secondary-SIAgreenLight: #ecf7f3;\n  secondary-SIAorange: #f3743d;\n  secondary-SIAorangeLight: #fbf1ec;\n  secondary-SIArose: #e6005f;\n  secondary-SIAroseLight: #fcf2f7;\n  secondary-SIAyellow: #dacd7e;\n  secondary-SIAyellowLight: #faf8ed; }\n\n.SIAJury {\n  padding-inline: 0px; }\n\n@media (max-width: 66rem) {\n  .SIAJury {\n    padding-inline: 16px; } }\n";
  const fileName = "SIAJury_SIAJury";
  const element = document.querySelector("style[data-sass-component='SIAJury_SIAJury']");
  if (!element) {
    const styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
const getMasterpreisAppHeaderData = (type, lang) => {
  const appHeaders = {
    ak: {
      appName: 'Masterpreis-Jury',
      link: `/${lang}/mp_architektur/jury`,
      label: 'masterpreis.mp_architektur.jury.name'
    },
    ig: {
      appName: 'Masterpreis-Jury',
      link: `/${lang}/mp_ingenieurbau/jury`,
      label: 'masterpreis.mp_ingenieurbau.jury.name'
    }
  };
  return appHeaders[type] || appHeaders['ig'];
};
const SIAJury = _ref => {
  let {
    item,
    translate,
    lang
  } = _ref;
  const appHeaderData = getMasterpreisAppHeaderData(item.masterpreis_type.masterpreis_code, lang);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "sia-jury"
  }, /*#__PURE__*/_react.default.createElement(_AppHeader.default, _extends({
    translate: translate
  }, appHeaderData)), item.media && /*#__PURE__*/_react.default.createElement(_PageMedia.default, item.media), item.links && item.links.length > 0 && /*#__PURE__*/_react.default.createElement(_JuryLinksGrid.default, {
    links: item.links,
    lang: lang
  }), /*#__PURE__*/_react.default.createElement(_JuryList.default, {
    data: item.jury_items
  }));
};
var _default = exports.default = SIAJury;